/**
 * Function that makes view model.
 * This function constrains page components to separate into state and action logic.
 *
 * ```ts
 *
 * export const viewModel = makeViewModel({
 *   useState(defaultState) {
 *     // write state logic here
 *
 *
 *    // return state on a page
 *    return {
 *    }
 *   },
 *   useAction(state) {
 *    // write action logic here
 *
 *     // return actions.
 *     return {
 *       updateProfile: mutate
 *     }
 *   }
 * })
 *
 * ```
 *
 * then Use view model on page component.
 *
 * const SamplePage: Page = () => {
 *   const state = viewModel.useState({})
 *   const { updateProfile } = viewModel.useAction(state)
 * }
 */

export const makeViewModel = <S extends State = {}, A extends Actions = {}>(
  callback: ViewModelFunc<S, A>
) => {
  return () => {
    const { state, actions } = callback()
    return {
      state,
      actions,
    }
  }
}

type ViewModelFunc<S extends State, A extends Actions> = () => {
  state: S
  actions: A
}

export interface State {}

export interface Actions {}
